import React from 'react';
import ErrorPage from '../customPage/ErrorPage';
import { log } from '../../actions/error'

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        //alert(error);
        return { hasError: true };
    }

    componentDidMount() {
        //window.onerror = this.logError;
    }

    componentDidCatch(error, info) {
        // Example "componentStack":
        //   in ComponentThatThrows (created by App)
        //   in ErrorBoundary (created by App)
        //   in div (created by App)
        //   in App
        //logComponentStackToMyService(info.componentStack);
        //console.log('error=' + error + ' = info = ' + JSON.stringify(info));

        this.logError(error, info);
    }

    logError(error, info) {
        //alert(JSON.stringify(args));
        const message = `AppGo error: error = ${error} / info = ${JSON.stringify(info)}`
        log(message);
    }

    render() {
        const style = {
            textAlign: 'center'
        }

        if (this.state.hasError) {
            // You can render any custom fallback UI
            //return <h1>Something went wrong.</h1>;
            return <div style={style}><ErrorPage /></div>
        }

        return this.props.children;
    }
}